import { Injectable } from '@angular/core';
import { environment } from '@env/environment';

@Injectable({
  providedIn: 'root',
})
export class MessageService {
  messages: string[] = [];

  add(message: string) {
    if (!environment.production) {
      console.log(message);
    }
    this.messages.push(message);
  }

  clear() {
    this.messages = [];
  }
}
